import React, { useState, useEffect } from 'react';
import {
    Container,
    TextField,
    Button,
    Box,
    Modal,
    Paper,
    Tooltip,
    Typography
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';

const EditNationality = () => {
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [NationalityName, setNationalityName] = useState('');
    const { NationalityId } = useParams();
    const navigate = useNavigate();

    // Static Nationality data
    const staticNationalityData = [
        { NationalityId: 1, NationalityName: 'Indian' },
        { NationalityId: 2, NationalityName: 'American' },
        { NationalityId: 3, NationalityName: 'African' },
        { NationalityId: 4, NationalityName: 'Chinese' },
        { NationalityId: 5, NationalityName: 'Korean' },
        { NationalityId: 6, NationalityName: 'Turkish' },
        { NationalityId: 7, NationalityName: 'Palestinian' },
        { NationalityId: 8, NationalityName: 'Greek' },
    ];

    useEffect(() => {
        // Find the Nationality to edit based on NationalityId
        const Nationality = staticNationalityData.find(
            Nationality => Nationality.NationalityId === parseInt(NationalityId)
        );
        if (Nationality) {
            setNationalityName(Nationality.NationalityName);
        } else {
            alert('Nationality not found');
        }
    }, [NationalityId]);

    const handleUpdate = () => {
        if (NationalityName) {
            console.log('Updated Nationality:', NationalityName);
            setShowSuccessModal(true);
        } else {
            alert('Please enter a Nationality');
        }
    };

    const handleCancel = () => {
        navigate(-1);
    };

    return (
        <Container mt={4}>
            <Box
                sx={{
                    backgroundColor: 'rgba(2, 78, 101, 1)',
                    padding: '12px 16px',
                    boxShadow: 3,
                    borderRadius: '4px 4px 0 0',
                    margin: '2px auto',
                    width: "100%",
                }}
            >
                <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
                    Edit Nationality
                </Typography>
            </Box>

            <Paper elevation={3} style={{
                padding: 16,
                width: '100%',
                margin: 'auto',
                marginTop: 6,
                backgroundColor: '#f8fdfeff'
            }}>
                <div>
                    <TextField
                        label="Nationality"
                        variant="outlined"
                        fullWidth
                        value={NationalityName}
                        onChange={(e) => setNationalityName(e.target.value)}
                        sx={{ mb: 3 }}
                    />
                    <Tooltip title={!NationalityName && "Enter Nationality"} arrow>
                        <span>
                            <Button
                                variant="contained"
                                onClick={handleUpdate}
                                sx={{
                                    mr: 2,
                                    backgroundColor: '#127498ff',
                                    '&:hover': { backgroundColor: '#116280ff' }
                                }}
                                disabled={!NationalityName}
                            >
                                UPDATE
                            </Button>
                        </span>
                    </Tooltip>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleCancel}
                    >
                        CANCEL
                    </Button>
                </div>
            </Paper>

            <Modal
                open={showSuccessModal}
                onClose={() => setShowSuccessModal(false)}
                aria-labelledby="success-modal-title"
                aria-describedby="success-modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        overflow: 'hidden',
                    }}
                >
                    <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
                        <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
                            Nationality Updated ✅
                        </Typography>
                    </Box>
                    <Box sx={{ padding: '20px' }}>
                        <Typography id="success-modal-description" sx={{ mb: 2 }}>
                            Nationality Updated Successfully
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                            <Button
                                onClick={() => {
                                    setShowSuccessModal(false);
                                    navigate(-1);
                                }}
                                variant="contained"
                                color="primary"
                            >
                                OK
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </Container>
    );
};

export default EditNationality;